import React from "react";
import styled, { css } from "styled-components";
import { visuallyHidden, primaryShade } from "../../../../../common/ui/Styles";

export enum AccessibilityButtonLayout {
  /** hidden via visuallyHidden */
  visuallyHidden,
  /** hidden via opacity, claims static space  */
  opacityHidden,
}

const Styled = {
  Button: styled.button<Pick<Props, "layout">>`
    text-decoration: underline;
    border-radius: 4px;
    color: ${primaryShade(6)};
    font-size: 13px;
    z-index: 9999;
    padding: 8px;
    text-align: center;
    ${({ layout }) =>
      layout === AccessibilityButtonLayout.visuallyHidden
        ? css`
            position: absolute;
            :not(:focus) {
              ${visuallyHidden}
            }
          `
        : css`
            :not(:focus) {
              opacity: 0;
            }
          `}
    background-color: white;
    outline: none;
    border: 2px solid ${primaryShade(6)};
  `,
};

export type Props = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  layout?: AccessibilityButtonLayout;
};

const AccessibilityButton: React.FC<Props> = ({
  layout = AccessibilityButtonLayout.visuallyHidden,
  children,
  ...otherProps
}) => {
  return (
    <Styled.Button layout={layout} {...otherProps}>
      {children}
    </Styled.Button>
  );
};

export default AccessibilityButton;
